export const FETCH_SETTINGS_REQUEST = 'FETCH_SETTINGS_REQUEST';
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const FETCH_SETTINGS_FAILURE = 'FETCH_SETTINGS_FAILURE';
export const UPDATE_BIDMODE_SUCCESS = 'UPDATE_BIDMODE_SUCCESS';
export const UPDATE_BIDMODE_FAILURE = 'UPDATE_BIDMODE_FAILURE';
